import React from "react";
import { GLOBAL_IMAGES, Buttons } from "../../assets/asset";

const AIModal = ({ isOpen, onClose, onGetStarted }) => {
  const messages = [
    "Hello, Math Explorer! 👋",
    "Welcome to Math Adventure Land! 🎉 Get ready to solve fun math problems popping up as you explore. Each challenge helps you become a math whiz! Ready to test your skills and have fun with numbers? Let's see how many you can conquer!",
  ];

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[70] flex items-center justify-center overflow-y-auto bg-[#071733]/78 px-4 py-6 backdrop-blur-xl backdrop-brightness-50"
      role="dialog"
      aria-modal="true"
      aria-labelledby="ai-modal-title"
    >
      <div
        aria-hidden="true"
        className="absolute inset-0 bg-[radial-gradient(circle_at_top,rgba(255,244,179,0.18),transparent_38%),linear-gradient(180deg,rgba(7,23,51,0.08),rgba(7,23,51,0.32))]"
      />
      <div
        className="relative isolate w-full max-w-3xl overflow-hidden rounded-[2rem] border-4 border-[#0B2B66] bg-[#FFF8E8] shadow-[0_28px_70px_rgba(7,23,51,0.48)]"
        style={{
          minHeight: "400px",
        }}
      >
        <div
          aria-hidden="true"
          className="absolute inset-0 opacity-20"
          style={{
            backgroundImage: `url(${GLOBAL_IMAGES.AiPopupBG})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
        <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(255,251,240,0.96),rgba(255,245,222,0.98))]" />
        <div
          aria-hidden="true"
          className="absolute inset-x-6 top-6 h-20 rounded-full bg-white/55 blur-2xl"
        />

        <button
          onClick={onClose}
          className="absolute right-4 top-4 z-20 rounded-full bg-white/80 p-1 shadow-md transition hover:bg-white"
          aria-label="Close AI assistant popup"
        >
          <img src={Buttons.cross} alt="Close" className="w-10 h-10" />
        </button>

        <div className="relative z-10 flex h-full min-h-[400px] flex-col p-6 pb-16 pt-10 md:p-8 md:pb-16">
          <div
            className="flex-grow overflow-y-auto rounded-[1.5rem] border border-white/70 bg-white/30 p-4 pr-3 shadow-[inset_0_1px_0_rgba(255,255,255,0.7)] md:p-5"
            style={{ minHeight: "280px" }}
          >
            <div className="flex items-start gap-3 mb-4">
              <img
                src={GLOBAL_IMAGES.progressReportImage}
                alt="AI"
                className="w-12 shrink-0"
              />
              <div
                className="w-full max-w-[80%] rounded-2xl border-2 border-[#0B2B66]/15 bg-white/92 p-4 shadow-[0_10px_24px_rgba(11,43,102,0.14)]"
                style={{ minHeight: "60px" }}
              >
                <p
                  id="ai-modal-title"
                  className="font-mali text-base font-bold text-[#0B2B66]"
                >
                  {messages[0]}
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3 mb-8">
              <img
                src={GLOBAL_IMAGES.progressReportImage}
                alt="AI"
                className="w-12 shrink-0"
              />
              <div
                className="w-full max-w-[80%] rounded-2xl border-2 border-[#0B2B66]/15 bg-white/92 p-4 shadow-[0_10px_24px_rgba(11,43,102,0.14)]"
                style={{
                  minHeight: "120px",
                }}
              >
                <p className="font-mali font-medium leading-7 text-[#243B63]">
                  {messages[1]}
                </p>
              </div>
            </div>
          </div>

          <div className="flex justify-center mt-auto">
            <button
              onClick={onGetStarted}
              className="rounded-full border-2 border-[#0B2B66] bg-gradient-to-r from-[#FFF27A] via-[#FFBE4D] to-[#FF8F1F] px-8 py-2.5 font-bold text-[#0B2B66] shadow-[0_5px_0_#0B2B66] transition hover:brightness-105 active:translate-y-[1px] active:shadow-[0_3px_0_#0B2B66]"
            >
              Get Started
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AIModal;
